import { shape, string } from "prop-types"

export const UserShape = shape({
    userId: string.isRequired,
    emailAddress: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    managerId: string.isRequired
})